import axios from './interceptors';
import { loadingActions } from '../redux/actions';
import { Store } from '../redux/stores';
import { HEXtoBlackOrWhite } from '../services/colors';

export const createTable = async (table) => {
    Store.dispatch(loadingActions.loadingStart('tables.createTable'));
    const defaultReposne = {tableId:null};
    try {
        let resp = await axios.post(process.env.REACT_APP_HOST + '/table/new', table);
        Store.dispatch(loadingActions.loadingEnd('tables.createTable'));

        return resp && resp.data && resp.data.payload ? resp.data.payload : defaultReposne;
    } catch (e) {
        Store.dispatch(loadingActions.loadingEnd('tables.createTable'));
        return typeof e.response !== 'undefined' ? e.response.data : defaultReposne;
    }
};

export const joinTable = async (table) => {
    Store.dispatch(loadingActions.loadingStart('tables.joinTable'));
    const defaultReposne = {status:'error', payload: {tables:[]}};
    try {
        let resp = await axios.post(process.env.REACT_APP_HOST + '/table/join', {
            "code": table.code
        });
        Store.dispatch(loadingActions.loadingEnd('tables.joinTable'));

        return resp && resp.data ? resp.data : defaultReposne;
    } catch (e) {
        Store.dispatch(loadingActions.loadingEnd('tables.joinTable'));
        return typeof e.response !== 'undefined' ? e.response.data : defaultReposne;
    }
};

export const listTables = async () => {
    Store.dispatch(loadingActions.loadingStart('tables.listTables'));
    const defaultReposne = {status:'error', payload: {tables:[]}};
    try {
        let resp = await axios.get(process.env.REACT_APP_HOST + '/table');
        Store.dispatch(loadingActions.loadingEnd('tables.listTables'));
        return resp && resp.data ? resp.data : defaultReposne;
    } catch (e) {
        Store.dispatch(loadingActions.loadingEnd('tables.listTables'));
        return typeof e.response !== 'undefined' ? e.response.data : defaultReposne;
    }
};

export const tableData = async (id) => {
    Store.dispatch(loadingActions.loadingStart('tables.tableData'));
    const defaultReposne = {status:'error', payload: {tables:[]}};
    try {
        let resp = await axios.get(process.env.REACT_APP_HOST + `/table/${id}`);
        Store.dispatch(loadingActions.loadingEnd('tables.tableData'));
        return resp && resp.data && resp.data.payload ? resp.data.payload : {};
    } catch (e) {
        Store.dispatch(loadingActions.loadingEnd('tables.tableData'));
        return typeof e.response !== 'undefined' ? e.response.data : defaultReposne;
    }
};

export const setTableSheet = async (id, templeteId) => {
    Store.dispatch(loadingActions.loadingStart('tables.setTableSheet'));
    const defaultReposne = {status:'error', payload: {tables:[]}};
    try {
        let resp = await axios.post(process.env.REACT_APP_HOST + `/table/${id}/sheettemplate`, {
            templeteId
        });
        Store.dispatch(loadingActions.loadingEnd('tables.setTableSheet'));
        return resp && resp.data && resp.data.payload ? resp.data.payload : {};
    } catch (e) {
        Store.dispatch(loadingActions.loadingEnd('tables.setTableSheet'));
        return typeof e.response !== 'undefined' ? e.response.data : defaultReposne;
    }
};

export const updateTable = async (id, data) => {
    Store.dispatch(loadingActions.loadingStart('tables.updateTable'));
    try {
        let resp = await axios.put(process.env.REACT_APP_HOST + `/table/edit/${id}`, data);
        Store.dispatch(loadingActions.loadingEnd('tables.updateTable'));
        return resp && resp.data && resp.data.payload ? resp.data.payload : {};
    } catch (e) {
        Store.dispatch(loadingActions.loadingEnd('tables.updateTable'));
        return typeof e.response !== 'undefined' ? e.response.data : {};
    }
};

export const removeTable = async (id) => {
    Store.dispatch(loadingActions.loadingStart('tables.removeTable'));
    try {
        let resp = await axios.delete(process.env.REACT_APP_HOST + `/table/remove/${id}`);
        Store.dispatch(loadingActions.loadingEnd('tables.removeTable'));
        return resp && resp.data && resp.data.payload ? resp.data.payload : {};
    } catch (e) {
        Store.dispatch(loadingActions.loadingEnd('tables.removeTable'));
        return typeof e.response !== 'undefined' ? e.response.data : {};
    }
};

export const highlightTable = async (id) => {
    Store.dispatch(loadingActions.loadingStart('tables.highlightTable'));
    try {
        let resp = await axios.post(process.env.REACT_APP_HOST + `/table/highlight/${id}`);
        Store.dispatch(loadingActions.loadingEnd('tables.highlightTable'));
        return resp && resp.data && resp.data.payload ? resp.data.payload : {};
    } catch (e) {
        Store.dispatch(loadingActions.loadingEnd('tables.highlightTable'));
        return typeof e.response !== 'undefined' ? e.response.data : {};
    }
};

export const denyJoinTable = async (id) => {
    Store.dispatch(loadingActions.loadingStart('tables.denyjoin'));
    try {
        let resp = await axios.post(process.env.REACT_APP_HOST + `/table/denyjoin/${id}`);
        Store.dispatch(loadingActions.loadingEnd('tables.denyjoin'));
        return resp && resp.data ? resp.data : {};
    } catch (e) {
        Store.dispatch(loadingActions.loadingEnd('tables.denyjoin'));
        return typeof e.response !== 'undefined' ? e.response.data : {};
    }
};

export const confirmJoinTable = async (id) => {
    Store.dispatch(loadingActions.loadingStart('tables.confirmjoin'));
    try {
        let resp = await axios.post(process.env.REACT_APP_HOST + `/table/confirmjoin/${id}`);
        Store.dispatch(loadingActions.loadingEnd('tables.confirmjoin'));
        return resp && resp.data ? resp.data : {};
    } catch (e) {
        Store.dispatch(loadingActions.loadingEnd('tables.confirmjoin'));
        return typeof e.response !== 'undefined' ? e.response.data : {};
    }
};

export const findTables = async (filter, page=0) => {
    Store.dispatch(loadingActions.loadingStart('tables.findTablesTables'));
    try {
        let resp = await axios.post(process.env.REACT_APP_HOST + `/find`,{
            page,
            filter,
        });
        Store.dispatch(loadingActions.loadingEnd('tables.findTablesTables'));
        return resp && resp.data ? resp.data : {};
    } catch (e) {
        Store.dispatch(loadingActions.loadingEnd('tables.findTablesTables'));
        return typeof e.response !== 'undefined' ? e.response.data : {};
    }
};

export const  getTableDetails = async (id) => {
    Store.dispatch(loadingActions.loadingStart('tables.getTableDetails'));
    try {
        let resp = await axios.get(process.env.REACT_APP_HOST + `/table/details/${id}`);

        resp.data.payload["gm"]["fgColor"] = HEXtoBlackOrWhite(resp.data.payload["gm"]["color"]);
        resp.data.payload["players"] = resp.data.payload["players"].map(p => ({...p, fgColor: HEXtoBlackOrWhite(p.color)}));

        Store.dispatch(loadingActions.loadingEnd('tables.getTableDetails'));
        return resp && resp.data ? resp.data : {};
    } catch (e) {
        Store.dispatch(loadingActions.loadingEnd('tables.getTableDetails'));
        return typeof e.response !== 'undefined' ? e.response.data : {};
    }
};


export const denouceTable = async (id, reason, note) => {
    Store.dispatch(loadingActions.loadingStart('friends.denouceTable'));
    try {
        let resp = await axios.post(process.env.REACT_APP_HOST + '/table/denouce/'+id, {reason, note});
        
        Store.dispatch(loadingActions.loadingEnd('friends.denouceTable'));

        return resp.data;
    } catch (e) {
        Store.dispatch(loadingActions.loadingEnd('friends.denouceTable'));
        return e.response ? e.response.data : e;
    }
};

export const askToJoinTable = async (id) => {
    Store.dispatch(loadingActions.loadingStart('friends.askToJoinTable'));
    try {
        let resp = await axios.post(process.env.REACT_APP_HOST + '/table/message/join/'+id);
        
        Store.dispatch(loadingActions.loadingEnd('friends.askToJoinTable'));

        return resp.data;
    } catch (e) {
        Store.dispatch(loadingActions.loadingEnd('friends.askToJoinTable'));
        return e.response ? e.response.data : e;
    }
};
